import { select } from 'd3-selection';
import { _cloneTemplate } from './utils.mjs';


function addFaqs(data) {
  const template = select('#faq-template');
  const cloneTemplate = _cloneTemplate.bind(template);
  const parent = select('#faq-list');

  data.forEach(function({ question, answer }) {
    const faq = cloneTemplate(parent);
    faq.select('.question').text(question);
    faq.select('.answer').html(answer);
  });
}


export { addFaqs };
